import { motion } from "framer-motion";
import { ArrowRight, Crown, Zap, Star, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export const PremiumPage = () => {
  const features = [
    { icon: Zap, title: "AI Integration", desc: "Powered by Gemini API" },
    { icon: Star, title: "Text-to-Image", desc: "AI image generation" },
    { icon: Lock, title: "Ticket System", desc: "Advanced support system" },
    { icon: Zap, title: "Advanced Anti-Raid", desc: "Server protection pro" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <Seo
        title="Premium Discord Bot con AI, Anti-Raid Pro e Automazioni"
        description="Sblocca il piano premium di NATIBOT con AI, ticket system, anti raid avanzato, automazioni evolute e moduli pro per Discord."
        keywords={[
          "premium discord bot",
          "discord ai bot premium",
          "advanced anti raid discord",
          "discord automation premium",
          "ticket bot premium",
        ]}
        path="/premium"
      />
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="container mx-auto max-w-6xl px-6 py-12"
      >
        <Link to="/" className="inline-block mb-6">
          <Button variant="outline" className="gap-2">
            <ArrowRight className="w-4 h-4 rotate-180" />
            Back Home
          </Button>
        </Link>
        <h1 className="text-4xl md:text-5xl font-bold mb-4 flex items-center gap-3">
          <Crown className="w-12 h-12 text-yellow-500" />
          Premium Features
        </h1>
        <p className="text-xl text-muted-foreground max-w-2xl">
          Sblocca features esclusive con il piano Premium
        </p>
      </motion.div>

      {/* Features Grid */}
      <div className="container mx-auto max-w-6xl px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feat, idx) => {
            const Icon = feat.icon;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                className="glass-card p-6 rounded-xl"
              >
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-semibold mb-2">{feat.title}</h3>
                <p className="text-muted-foreground">{feat.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* Pricing */}
      <div className="container mx-auto max-w-6xl px-6 py-12">
        <div className="glass-card p-8 rounded-xl text-center">
          <h2 className="text-3xl font-bold mb-2">Premium Plan</h2>
          <div className="text-5xl font-bold mb-4">
            <span className="text-primary">€4.99</span>
            <span className="text-muted-foreground text-lg ml-2">/mese</span>
          </div>
          <p className="text-muted-foreground mb-6">Accesso a tutte le features premium</p>
          <Link to="/dashboard">
            <Button size="lg" className="gap-2">
              Attiva Premium
              <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PremiumPage;
